<template>
  <div class="image-text-container">
    <el-tabs
      class="content"
      v-model="currentArticleType"
    >
      <el-tab-pane
        v-for="item in articleTypeList"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      >
        <keep-alive>
          <components
            v-show="currentArticleType === item.name"
            :is="item.name"
            :ref="item.name"
            :article="documentInfo"
          />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
    <el-tabs
      class="tabs-container"
      v-model="currentTab"
    >
      <el-tab-pane
        v-for="item in tabList"
        :key="item.name"
        :label="item.name"
        :name="item.label"
      >
        <keep-alive>
          <components
            v-show="currentTab === item.label"
            :is="item.label"
            :ref="item.label"
            :table-data="reviewArr"
            :empty="empty"
            @startCheckContent="getReviewData"
            @handleRowClick="highLightWord"
          />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
    <div
      class="operate-box"
      v-show="isShowSubmit"
    >
      <el-button @click="upload('submit')">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import jlxkAPIS from '@apis/jlxk'
import imageText from './components/imageText'
import imageTextCheck from '../editor/components/textAndFilm'
import {
  transContentChar,
  checkProofWord
} from '@assets/js/SensitiveWordsUtil.js'
import $ from 'jquery'
export default {
  name: 'Editor',
  components: {
    imageTextCheck,
    imageText
  },
  props: {},
  data() {
    return {
      breadMenuData: ['数据审读编辑'],
      // 图文
      // layoutId: this.$route.query.layoutId,
      id: this.$route.query.id,
      currentArticleType: 'imageText',
      articleTypeList: [
        {
          name: 'imageText',
          label: '图文',
          code: 1
        }
      ],
      article: '',
      checkContent: '',
      documentInfo: {
        id: '',
        status: '',
        pubdate: '',
        oriSystem: 0,
        attachments: [],
        keywords: '',
        title: '',
        created: '',
        articleTypeId: '',
        department: '',
        // author: '无',
        content: '',
        source: '无',
        location: '',
        originalPicUrl: [],
        coverPicUrl: '',
        publisher: '',
        topDataCategoryId: '',
        secDataCategoryId: ''
      },
      // 校对
      currentTab: 'imageTextCheck',
      tabList: [
        {
          name: '校对',
          label: 'imageTextCheck',
          isShow: auth_review_enabled
        }
      ],
      reviewArr: [],
      isShowSubmit: false,
      empty: ''
    }
  },
  mounted() {
    this.$store.commit('UPDATE_BreadMenuData', [...this.breadMenuData])
    this.getSpecialDetail()
  },
  methods: {
    // 稿件详情
    async getSpecialDetail() {
      const params = {
        id: this.id
      }
      const { status, data } = await jlxkAPIS.postSpcialDetail({ data: params })
      if (status === 0 && data) {
        this.article = data.content
          .replace(
            new RegExp(`(\r\n\t)|(\r\n)|(\n)|(<br /><br />)`, 'g'),
            '&nbsp1'
          ).split('&nbsp1')
        this.checkContent = data.content
        Object.keys(this.documentInfo).forEach(item => {
          this.documentInfo[item] = data[item] || ''
          if (item === 'originalPicUrl') {
            this.documentInfo[item] = data[item].split(';')
          }
          if (item === 'status') {
            this.documentInfo.status = data.oristatus
          }
          this.documentInfo.content = this.formatContent(data.content)
        })
        this.$nextTick(() => {
          this.allImgList = []
          let imgArr = document.querySelectorAll(
            '.data-view-detail-container .content img'
          )
          imgArr.forEach(item => {
            this.allImgList.push(item.src)
          })
          if (this.$route.query.check && this.id) {
            this.getReviewResult()
          }
        })
      }
    },
    // 审核结果列表
    async getReviewResult() {
      this.reviewArr = []
      this.empty = ' '
      let { status, data } = await jlxkAPIS.postReviewResult({
        params: { docId: this.$route.query.id }
      })
      if (status === 0 && data) {
        if (data.length !== 0) {
          this.reviewArr = data.map(item => {
            item.checkedWord = item.pickedWord
            item.type = item.inspectType
            item.initOffset = Number(item.offset)
            item.offset = Number(item.offset)
            item.inspectCategory = item.inspectCategor || '错误'
            item.level =
              item.inspectCategory === '错误' ? 'error' : 'suspicious'
            return item
          })
          if (this.documentInfo.content) {
            this.$refs.imageTextCheck[0].isStartCheck = true
          }
          this.updateContent()
        } else {
          this.isShowSubmit = true
          this.empty = '无错误'
          this.$refs.imageTextCheck[0].isStartCheck = true
        }
      } else {
        this.reviewArr = []
        this.empty = '无可展示审校内容'
      }
    },
    // 审读结果
    async getReviewData() {
      let content = this.checkContent.replace(
        new RegExp(`(\r\n\t)|(\r\n)|(\n)|(<br /><br />)`, 'g'),
        ''
      ).replace(/\s+/g, ' ')
      let params = {
        docId: this.$route.query.id,
        type: 0,
        content: content
      }
      let { status, data } = await jlxkAPIS.postReviewCheck({ data: params })
      if (status === 0 && data) {
        if (data.length !== 0) {
          this.reviewArr = data.map(item => {
            item.checkedWord = item.pickedWord
            item.type = item.inspectType
            item.initOffset = Number(item.offset)
            item.offset = Number(item.offset)
            item.inspectCategory = item.inspectCategor || '错误'
            item.level =
              item.inspectCategory === '错误' ? 'error' : 'suspicious'
            return item
          })
          if (this.documentInfo.content) {
            this.$refs.imageTextCheck[0].isStartCheck = true
          }
          this.updateContent()
        } else {
          this.isShowSubmit = true
          this.empty = '无错误'
          this.$refs.imageTextCheck[0].isStartCheck = true
        }
      } else {
        this.empty = '无可展示审校内容'
        this.reviewArr = []
      }
    },
    updateContent() {
      this.isShowSubmit = true
      let arr = []
      let incrLen = 0
      this.reviewArr.forEach((item, index) => {
        if (item.offset === 0 && String(item.paragraphIndex) === '0') return false
        let transItemContent = transContentChar(item.checkedWord)
        let itemIncrLen = transItemContent.length - item.checkedWord.length
        incrLen += itemIncrLen
        if (index > 0) {
          item.offset = item.offset + incrLen
        }
        item.checkedWord = transItemContent
        let arrIndex = arr.findIndex(innerItem => {
          return innerItem.checkedWord === item.checkedWord
        })
        item.offset = this.getParagraphWord(
          item.offset,
          Number(item.paragraphIndex) - 1
        )
        let contentIndex =
            this.article
              .join('')
              .substring(0, item.offset)
              .split(item.checkedWord).length - 1
        if (arrIndex === -1) {
          arr.push(item)
          arr[arr.length - 1].posList = [
            {
              contentIndex: contentIndex,
              idBack: item.classId,
              cType: item.level
            }
          ]
        } else {
          arr[arrIndex].posList.push({
            contentIndex: contentIndex,
            idBack: item.classId,
            cType: item.level
          })
        }
      })
      let contentCheck = checkProofWord(
        this.checkContent,
        arr,
        'article-proof',
        'autocheck'
      )
      console.info(arr)
      this.documentInfo.content = this.formatContent(contentCheck)
    },
    formatContent(content) {
      let result = content
        .replace(
          new RegExp(`(\r\n\t)|(\r\n)|(\n)|(<br /><br />)`, 'g'),
          '</div><div>'
        )
        .replace(/\s+/g, ' ')
        // 视频添加结束标签和controls属性
      result = result
        .replace(/< img/g, '<img')
        .replace(/< *video/g, '<video controls')
      return result
    },
    // 获取段落字符数
    getParagraphWord(offset, parIndex) {
      let result = 0
      this.article.forEach((item, index) => {
        if (parIndex <= index) return false
        result += item.length
      })
      result += offset
      return result
    },
    // 稿件操作：返回、重置、存草稿、提交
    async upload() {
      let arr = this.$refs.imageTextCheck[0].checkData
      arr.forEach(item => {
        item.offset = item.initOffset
        item.initOffset = undefined
      })
      let checkParams = {
        docId: this.id,
        review_result: JSON.stringify(this.$refs.imageTextCheck[0].checkData)
      }
      let { status } = await jlxkAPIS.postReviewEditResult({
        data: checkParams,
        headers: { 'Content-Type': 'application/json' }
      })
      if (status === 0) {
        window.close()
      }
    },
    highLightWord(value) {
      // 提示词并且不是手工添加可定位
      if (value.offset === 0 && String(value.paragraphIndex) === '0') {
        return false
      }
      let obj = $('#container')
      let param = `article-proof-founder-level-${value.classId}`
      if (obj.find('#' + param)) {
        obj.find('span').removeClass('errorSelect')
        obj.find('#' + param).addClass('errorSelect')
        let target = document.querySelector('#' + param)
        target.scrollIntoView()
      }
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
.image-text-container {
  justify-content: space-between;
  display: flex;
  .operate-box {
    position: absolute;
    bottom: 13px;
    right: 20px;
    background: #fff;
    .el-button {
      height: 28px;
      padding: 0 12px;
      border-radius: 3px;
      background: #ffffff;
      border: 1px solid #d9e3f4;
      font-family: Microsoft YaHei;
      font-size: 12px;
      color: #3780f7;
      &:last-child {
        background: #3780f7;
        color: #fff;
      }
      + .el-button {
        margin-left: 10px;
      }
    }
  }
  .content {
    height: calc(100vh - 110px);
    overflow: auto;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
  }
  /deep/ .el-tabs {
    flex: 1;
    .el-tabs__header {
      width: 100%;
      margin: 0;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
      border-radius: 10px 10px 0 0;
      .el-tabs__nav-wrap {
        overflow: auto;
        .el-tabs__nav-scroll {
          height: 49px;
          overflow: hidden;
        }
        &::after {
          display: none;
        }
      }
      .el-tabs__active-bar {
        bottom: -4px;
        width: 32px !important;
      }
      .el-tabs__item {
        height: 45px;
        line-height: 45px;
        font-size: 15px;
        color: #454647;
        padding: 0 30px;
        box-shadow: none;
        &.is-active {
          color: #4497ec;
        }
      }
    }
    .el-tabs__content {
      overflow: initial;
      .editor-content {
        display: flex;
        justify-content: space-between;
        min-height: calc(100vh - 210px);
        > div {
          &:first-child {
            flex: 1;
            min-height: calc(100vh - 210px);
            background-color: #fff;
            border-radius: 0 0 10px 10px;
            box-shadow: -4px 4px 10px -6px rgba(0, 0, 0, 0.1),
              4px 4px 10px -6px rgba(0, 0, 0, 0.1);
            border-top: 1px solid #e7e7e7;
          }
        }
        .common-property-tag {
          margin-left: 12px;
          flex-shrink: 0;
          margin-top: -49px;
        }
      }
    }
  }
  /deep/ .tabs-container.el-tabs {
    margin: 0px 0 0 12px;
    width: 440px;
    @extend .comBackground;
    border-radius: 10px;
    flex-shrink: 0;
    flex: none;
    .el-tabs__header {
      width: 440px;
      box-shadow: none;
      .el-tabs__nav-wrap {
        &::after {
          display: block;
          height: 1px;
          left: 20px;
          width: calc(100% - 40px);
        }
        .el-tabs__active-bar {
          max-width: 80px;
        }
        #tab-commonTag {
          width: 140px;
          text-align: right;
          background: url("~@assets/icons/icon-jlxk-biaoqian.png") no-repeat
            24px 15px;
        }
      }
    }
    .el-tabs__content {
      padding-top: 12px;
    }
    .common-property-tag {
      margin: 0 !important;
      box-shadow: none;
      .bd {
        max-height: calc(100vh - 218px);
      }
    }
  }
}
</style>
